import { render, staticRenderFns } from "./AccidentTypeList.vue?vue&type=template&id=28550f2a"
import script from "./AccidentTypeList.vue?vue&type=script&lang=js"
export * from "./AccidentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports